<template>
  <div class="loader">Loading...</div>
</template>

<script setup>
</script>
